import { ref } from 'vue';

export const menuClickCount = ref(0);